/* eslint-disable no-param-reassign */
import {select} from "../../../../../shared/SagaService";

export function* parseAccounts(transaction) {
    const accounts = yield select(state => state.List.accounts);
    const invalidAccounts = [];

    const accountsFlat = accounts.flatMap(account => {
        if (!account.children)
            return [account];
        return [account, ...account.children];
    });

    if (transaction.account_id && !accountsFlat.find(acc => acc.id === transaction.account_id)) {
        invalidAccounts.push(transaction.autosave_text_values.account_id);
        transaction.account_id = null;
    }

    if (transaction.account2_id && !accountsFlat.find(acc => acc.id === transaction.account2_id)) {
        invalidAccounts.push(transaction.autosave_text_values.account2_id);
        transaction.account2_id = null;
    }
    return invalidAccounts;
}
